import '../wwwroot/js/profint-dialogs.js';
import '../wwwroot/js/shared-file-picker.js';
import '../wwwroot/css/shared-file-picker.css';

export type FilePickerState = { files: File[]; disabled: boolean; pending: boolean; revision: number; valid: boolean; error: string };
export type FilePickerOptions = { label?: string; onChange?(state: FilePickerState): void };
export type FilePickerControl = {
  input: HTMLInputElement; wrapper: HTMLElement; getState(): FilePickerState;
  sync(): FilePickerState; validate(reveal?: boolean): boolean; requestRemove(index?: number | null): Promise<boolean>;
  focus(): void; destroy(): void;
};
type SharedFilePicker = { mount(input: HTMLInputElement, options?: FilePickerOptions): FilePickerControl | null; init(root?: ParentNode): FilePickerControl[]; eligible(input: HTMLInputElement): boolean; destroy(root?: ParentNode): void };
const api = () => (window as unknown as { ProfintFilePicker: SharedFilePicker }).ProfintFilePicker;
export const mountFilePicker = (input: HTMLInputElement, options?: FilePickerOptions) => api().mount(input, options);
export const initFilePickers = (root?: ParentNode) => api().init(root);
export const canMountFilePicker = (input: HTMLInputElement) => api().eligible(input);
export const destroyFilePickers = (root?: ParentNode) => api().destroy(root);
